module.exports = __webpack_public_path__ + "fonts/FuturaPT-Medium.a1c0db3.woff2";